import { LucideIcon } from 'lucide-react';

interface InfoCardProps {
  icon: LucideIcon;
  title: string;
  value: string;
  borderColor: string;
  iconBackgroundColor: string;
  iconColor: string;
}

export function InfoCard({
  icon: Icon,
  title,
  value,
  borderColor,
  iconBackgroundColor,
  iconColor,
}: InfoCardProps) {
  return (
    <div
      className='rounded-xl p-4 border-2 transition-all duration-300 hover:shadow-md'
      style={{ borderColor }}
    >
      <div className='flex items-start gap-3'>
        <div
          className='w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0'
          style={{ backgroundColor: iconBackgroundColor }}
        >
          <Icon className='w-5 h-5' style={{ color: iconColor }} />
        </div>
        <div className='flex-1 min-w-0'>
          <p className='text-xs font-medium text-gray-600 mb-1'>{title}</p>
          <p
            className='text-lg font-semibold truncate'
            style={{ color: 'var(--clinic-text)' }}
          >
            {value}
          </p>
        </div>
      </div>
    </div>
  );
}

